import { ReturnAddressSchema } from "@redotech/redo-model/return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const approvalProductInfoSchema = z.object({
  _id: z.string(),
  weight: z.number().optional(),
  weightUnit: z.string().optional(),
  shipBack: z.boolean().optional(),
  grams: z.number().optional(),
  hsCode: z.string().optional(),
});

// The form's `id` is a symbol and does not survive serialization, so it is
// intentionally omitted — the server reconstructs shipment group ids by index.
export const approvalLabelSchema = z.object({
  items: z.array(z.object({ _id: z.string() }).passthrough()),
  weight: z.object({ amount: z.string(), unit: z.enum(["oz", "lbs", "g"]) }),
  returnToAddress: ReturnAddressSchema.optional(),
  labelNote: z.string().optional(),
});

export const approveReturnInput = z.object({
  returnId: zExt.objectId(),
  customerNotes: z.string().optional(),
  customerImages: z.array(z.string()).optional(),
  sendNotification: z.boolean().optional(),
  orderTags: z.array(z.string()).optional(),
  products: z.array(approvalProductInfoSchema),
  selectedAddress: ReturnAddressSchema.optional(),
  multipleLabels: z.array(approvalLabelSchema).optional(),
});

export const approveReturn = {
  name: "approveReturn" as const,
  input: approveReturnInput,
  output: z.null(),
};
